import { publicComponentOption } from "dependencies/base"
import { toSelectOpt } from "utils"
const optDes = {
  ...publicComponentOption,
  value: "选中项",
  selectOptions: "下拉选项",
  opacity: "透明度",
  boxShadowColor: "阴影颜色",
  boxShadowH: "阴影x轴的偏移量",
  boxShadowV: "阴影y轴的偏移量",
  boxShadowBlur: "阴影模糊值",
  boxShadowSpread: "阴影扩散值",
  borderBottomLeftRadius: "左下圆角",
  borderBottomRightRadius: "右下圆角",
  borderTopRightRadius: "右上圆角",
  borderTopLeftRadius: "左上圆角",
  linkValue: "链接值"
}
export const getOptDes = toSelectOpt.bind(this, optDes)
